import React, { useEffect, useState } from "react";
import "../../styles/AppHeader.css";
import filterButton from '../../assets/logos/FilterButton.svg';
import { useLocation } from "react-router-dom";
import { agenticGet } from "../../utils/agenticApiClient";

const AppHeader = ({ title, onProgramChange }) => {
  const [selectedValue, setSelectedValue] = useState("Rebuild Florida Housing Repair and Replacement Program");
  const [url, setUrl] = useState(false);
  const [programs, setPrograms] = useState([]);
  const location = useLocation();

  // Fetch the filters (programs) from the API
  const fetchFilters = async () => {
    try {
      const response = await agenticGet('/programs');
      if (response && response.programs) {
        setPrograms(response.programs);
        onProgramChange?.(selectedValue);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };
  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    if (location.pathname === '/apps') {
      setUrl((prevUrl) => !prevUrl); // Toggle url state only when needed
    }
  }, [location.pathname]);
  const handleChangeProgram = (e) => {
    setSelectedValue(e?.target?.value);
    onProgramChange?.(e.target.value);
  }
  return (
    <div className="AppHeaderContainer">
      <p className="AppHeaderText">{title}</p>

      <div className="RightActions">
        <div className="SearchBox">
          <span className="SearchIcon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3332 13.3337L9.77762 9.7781M2.6665 6.81514C2.6665 7.35988 2.7738 7.89929 2.98226 8.40257C3.19073 8.90584 3.49628 9.36313 3.88147 9.74832C4.26666 10.1335 4.72395 10.4391 5.22722 10.6475C5.7305 10.856 6.26991 10.9633 6.81465 10.9633C7.35939 10.9633 7.8988 10.856 8.40208 10.6475C8.90536 10.4391 9.36264 10.1335 9.74784 9.74832C10.133 9.36313 10.4386 8.90584 10.647 8.40257C10.8555 7.89929 10.9628 7.35988 10.9628 6.81514C10.9628 6.2704 10.8555 5.73099 10.647 5.22771C10.4386 4.72444 10.133 4.26715 9.74784 3.88196C9.36264 3.49677 8.90536 3.19122 8.40208 2.98275C7.8988 2.77429 7.35939 2.66699 6.81465 2.66699C6.26991 2.66699 5.7305 2.77429 5.22722 2.98275C4.72395 3.19122 4.26666 3.49677 3.88147 3.88196C3.49628 4.26715 3.19073 4.72444 2.98226 5.22771C2.7738 5.73099 2.6665 6.2704 2.6665 6.81514Z" stroke="#B4BAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>

          <input
            type="text"
            placeholder="Search"
            className="SearchInput"
            disabled={url ? 'true' : 'false'}
          />
        </div>

        {url ? (
          <button className="filter-button">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.33301 4H8.33301M2.33301 8H6.99967M2.33301 12H6.99967M9.66634 10L11.6663 12M11.6663 12L13.6663 10M11.6663 12V4" stroke="#8E97A3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        ) : (
          <div>
            <select
              className="SearchBox"
              value={selectedValue}
              onChange={handleChangeProgram}
            >
              <option value="">Choose</option>
              {programs.length > 0 ? (
                programs.map((program, index) => (
                  <option key={index} value={program}>
                    {program}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No programs available
                </option>
              )}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppHeader;